import { render, staticRenderFns } from "./PulmotilAssumptionModalUpdated.vue?vue&type=template&id=2fdf1f12&scoped=true&"
import script from "./PulmotilAssumptionModalUpdated.vue?vue&type=script&lang=ts&"
export * from "./PulmotilAssumptionModalUpdated.vue?vue&type=script&lang=ts&"
import style0 from "./PulmotilAssumptionModalUpdated.vue?vue&type=style&index=0&id=2fdf1f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf1f12",
  null
  
)

export default component.exports